import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import icon from "./../images/icon.png"
import { motion } from "framer-motion"
import Search from "./Search"

function Navbar() {
  const [isSearchBarVisible, setIsSearchBarVisible] = useState(false)

  const openSearchBar = () => setIsSearchBarVisible(true)
  const closeSearchBar = () => setIsSearchBarVisible(false)

  const links = [
    {
      name: "Home",
      linkTo: "/",
    },
    {
      name: "Blogs",
      linkTo: "/blogs",
    },
    {
      name: "About",
      linkTo: "/about",
    },
  ]
  const [hasScrolled, setHasScrolled] = useState(false)

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  }, [])

  const handleScroll = event => {
    const scrollHeight = window.pageYOffset
    scrollHeight > 50 ? setHasScrolled(true) : setHasScrolled(false)
  }

  return (
    <>
      <motion.nav
        variants={hasScrolled ? navbarContainerVariants : noVariants}
        initial="hidden"
        animate="visible"
        className="navbar px-md-5 fixed-top py-1"
      >
        <div className="container-fluid d-block d-md-flex align-items-center justify-content-between">
          <div className="navbar-brand text-center mx-auto mx-md-2 justify-content-center d-flex pb-2">
            <Link to="/">
              <motion.img
                variants={navbarVariants}
                whileHover="onHover"
                whileTap="onTap"
                src={icon}
                alt="Icon"
                // className="navbar-brand mx-2"
                className="img-fluid"
                style={{ height: "5vh" }}
              />
            </Link>
          </div>
          <div className="mt-md-1 align-items-center ">
            <ul className="list-unstyled d-flex align-items-center justify-content-center mb-0 mr-md-2">
              {links.map(link => (
                <li key={link.name} className="nav-item mx-md-1">
                  <motion.h6
                    variants={navbarVariants}
                    whileHover="onHover"
                    whileTap="onTap"
                  >
                    <Link to={link.linkTo} className="nav-link text-white">
                      {link.name}
                    </Link>
                  </motion.h6>
                </li>
              ))}
              <li
                className="nav-item mx-1"
                onClick={isSearchBarVisible ? closeSearchBar : openSearchBar}
              >
                <motion.h6
                  variants={navbarVariants}
                  whileHover="onHover"
                  whileTap="onTap"
                  style={{ cursor: "pointer" }}
                >
                  <span className="nav-link text-white">Search</span>
                </motion.h6>
              </li>
            </ul>
          </div>
        </div>
      </motion.nav>
      <Search visible={isSearchBarVisible} closeSearchBar={closeSearchBar} />
    </>
  )
}

export default Navbar

const navbarContainerVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    backgroundColor: "#121212",
    boxShadow: "0 15px 30px rgba(255, 255, 255, 0.4)",
    transition: {
      delay: 0.2,
    },
  },
}

const noVariants = {}

const navbarVariants = {
  hidden: {
    scale: 0,
  },
  visible: {
    scale: 1,
    transition: { delay: 0.2, duration: 0.5 },
  },
  onHover: {
    scale: 1.05,
  },
  onTap: {
    scale: 0.9,
  },
}
